import countriesData from './countriesData.json';

export default {
    data: countriesData
};
